export const hideSuperfluousEnglishClass = (user) =>
  user && user.hideSuperfluousEnglish
    ? 'hide-superfluous-english'
    : ''
